import React from 'react';
import { CTAButton, TrustLine } from './CTAButton';
import { BOX_IMAGE, PURCHASE_ANCHOR } from '../data/content';
export function FinalCTA() {
  return <section className="bg-petrol px-4 py-7 text-center sm:px-6" data-id="element-50" data-mp="3uei1xeuj5o1t">
      <div className="mx-auto max-w-2xl" data-id="element-51" data-mp="c7k5ny2p8nov">
        <h2 className="font-heading text-lg font-extrabold uppercase text-gold sm:text-2xl" data-id="element-52" data-mp="c4fv8iyn4vpr">
          One last question
        </h2>
        <p className="mx-auto mt-2 max-w-xl text-sm leading-snug text-cream/90 sm:text-base" data-id="element-53" data-mp="m46oyifdn6os">
          How many times have you started a care day knowing what needed to get
          done... but still had to rebuild the schedule, check scattered notes
          and organize everything again? You can keep moving between notes,
          messages, checklists and separate documents. Or you can open one
          organized professional system.
        </p>
        <p className="mt-2 font-heading text-sm font-bold uppercase text-sage sm:text-base" data-id="element-54" data-mp="14td8g7nzw2bn">
          Plan. Organize. Record. Communicate.
        </p>

        <a href={PURCHASE_ANCHOR} className="mt-3 block" data-id="element-55" data-mp="2c5pydzhmdk4a">
          <img src={BOX_IMAGE} alt="CAREGIVER READY™ complete system" className="mx-auto w-full max-w-[240px] drop-shadow-2xl" data-id="element-56" data-mp="2h3rgoi781fep" />
        </a>

        <p className="mt-2 font-heading text-xl font-extrabold uppercase text-white sm:text-2xl" data-id="element-57" data-mp="2m571qa9eflx3">
          💙 CAREGIVER READY™
        </p>
        <p className="font-heading text-xs font-semibold uppercase tracking-wide text-cream/85 sm:text-sm" data-id="element-58" data-mp="2v4al7fcha3c4">
          The Complete Daily Care Organization System
        </p>
        <p className="mt-1 text-xs text-cream/75 sm:text-sm" data-id="element-59" data-mp="34tbxovjte2lc">
          Daily Planning • Personal Care • Meals &amp; Hydration • Mobility &amp;
          Safety • Care Notes • Handoffs
        </p>

        <p className="mt-3 font-heading text-base font-extrabold uppercase text-gold sm:text-lg" data-id="element-60" data-mp="3eri2pm0x3ouf">
          🔥 Get the complete system today
        </p>
        <div className="mx-auto mt-2 max-w-md" data-id="element-61" data-mp="3itwgvstn60fd">
          <CTAButton label="💙 Get CAREGIVER READY™" sub="Immediate Access • Digital Delivery" target="checkout" className="!bg-gold !text-deep !shadow-[0_8px_0_0_#A5854D]" data-id="element-62" data-mp="1jod0qlp67e08" />
          <TrustLine className="mt-3 !text-cream/85" data-id="element-63" data-mp="1showj1epjodg" />
        </div>
      </div>
    </section>;
}